import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNavigationStore = defineStore('navigationStore', () => {
  const shouldLoadBackInContext = ref(
    sessionStorage.getItem('shouldLoadBackInContext') === 'true'
  )
  const backInContextUrl = ref<string | null>(
    sessionStorage.getItem('backInContextUrl') || null
  )
  const backInContextType = ref<string>(
    sessionStorage.getItem('backInContextType') || 'inbox'
  )
  const viewingItem = ref<string>(sessionStorage.getItem('viewingItem') || '')

  const registeredUrl = ref<string | null>(
    sessionStorage.getItem('registeredUrl')
  )

  function enableBackInContext(url: string, type: string, item: string): void {
    shouldLoadBackInContext.value = true
    backInContextUrl.value = url
    backInContextType.value = type
    viewingItem.value = item

    sessionStorage.setItem('shouldLoadBackInContext', 'true')
    sessionStorage.setItem('backInContextUrl', url)
    sessionStorage.setItem('backInContextType', type)
    sessionStorage.setItem('viewingItem', viewingItem.value ?? '')
  }

  function clearData(): void {
    shouldLoadBackInContext.value = false
    backInContextUrl.value = null
    backInContextType.value = 'overview'
    viewingItem.value = ''
    registeredUrl.value = null
    sessionStorage.removeItem('shouldLoadBackInContext')
    sessionStorage.removeItem('backInContextUrl')
    sessionStorage.removeItem('backInContextType')
    sessionStorage.removeItem('viewingItem')
    sessionStorage.removeItem('registeredUrl')
  }

  function registerForUrl(url: string): void {
    if (!shouldLoadBackInContext.value || registeredUrl.value === url) {
      return
    }

    if (registeredUrl.value === null) {
      registeredUrl.value = url
      sessionStorage.setItem('registeredUrl', registeredUrl.value)
    } else {
      clearData()
    }
  }

  return {
    shouldLoadBackInContext,
    backInContextUrl,
    backInContextType,
    viewingItem,
    enableBackInContext,
    clearData,
    registerForUrl,
  }
})
